import { ColDef, RowSpanParams } from 'ag-grid-community';


export const Reserved4473TableColumnDef: ColDef[] = [
  {
    // ID
    headerName: 'ID',
    field: 'id',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
    hide: true,
  },
  {
    // Full Name
    headerName: 'Full Name',
    field: 'full_name',
    resizable: true,
    width: 250,
    filter: 'agTextColumnFilter',
    valueGetter: (params) => {
      const { name_first, name_middle, name_last } = params.data;
      return `${name_first.toUpperCase()} ${name_middle.toUpperCase()} ${name_last.toUpperCase()}`;
    },
  },
  {
    // Address
    headerName: 'Address',
    field: 'address_street',
    resizable: true,
    flex: 1,
    filter: 'agTextColumnFilter',
    valueGetter: (params) => {
      const { address_street, address_city, address_zip_code } = params.data;
      return `${address_street.toUpperCase()}, ${address_city.toUpperCase()}, ${address_zip_code}`;
    },
  },
  {
    // Birthday
    headerName: 'Birthday',
    field: 'birthday',
    resizable: true,
    width: 150,
    filter: 'agTextColumnFilter',
    valueGetter: (params) => {
      const { birth_day, birth_month, birth_year } = params.data;
      return `${birth_day}-${birth_month}-${birth_year}`;
    },
  },
  {
    // NICS Number
    headerName: 'NICS Number',
    field: 'nics_number',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
  },
  {
    // Reserved Date
    headerName: 'Reserved Date',
    field: 'reserved_date',
    resizable: true,
    width: 150,
    filter: 'agTextColumnFilter',
    valueGetter: (params) => {
      const { transferee_cert_month, transferee_cert_day, transferee_cert_year } = params.data;
      return `${transferee_cert_month}-${transferee_cert_day}-${transferee_cert_year}`;
    },
  }
];
